var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.0415 8.33333C6.0415 6.14721 7.81371 4.375 9.99985 4.375C12.1859 4.375 13.9582 6.14721 13.9582 8.33333C13.9582 10.5195 12.1859 12.2917 9.99985 12.2917C7.81371 12.2917 6.0415 10.5195 6.0415 8.33333ZM9.99985 5.625C8.5041 5.625 7.2915 6.83756 7.2915 8.33333C7.2915 9.82908 8.5041 11.0417 9.99985 11.0417C11.4956 11.0417 12.7082 9.82908 12.7082 8.33333C12.7082 6.83756 11.4956 5.625 9.99985 5.625Z",
    fill: "#F77E0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.93683 7.38079C3.2321 3.79861 6.22556 1.04175 9.81986 1.04175H10.1799C13.7742 1.04175 16.7676 3.79861 17.0629 7.38079C17.2215 9.30508 16.6271 11.2158 15.4049 12.7106L11.4107 17.5954C10.6815 18.4872 9.31819 18.4872 8.58903 17.5954L4.59483 12.7106C3.37261 11.2158 2.77821 9.30508 2.93683 7.38079ZM9.81986 2.29175C6.8761 2.29175 4.42443 4.54965 4.1826 7.48348C4.05059 9.085 4.54529 10.6752 5.56251 11.9193L9.55669 16.8042C9.78578 17.0842 10.2139 17.0842 10.443 16.8042L14.4372 11.9193C15.4544 10.6752 15.9491 9.085 15.8171 7.48348C15.5753 4.54965 13.1236 2.29175 10.1799 2.29175H9.81986Z",
    fill: "#F77E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationPoint);
export default __webpack_public_path__ + "static/media/locationPoint.bba000a9670515036256dd0eb08f5a0f.svg";
export { ForwardRef as ReactComponent };